/**
 * MV2-577 Part 2 (3.4) — `GET organizations/:organizationId/performance/
 * trainer-earnings` and `…/trainer-earnings/items` (`trainer_earnings_read`;
 * 403 for an employed trainer). Fees only — never a gross, the fee terms or a
 * margin. The project's usual `{ data }` envelope, like `performanceStats`.
 */
import type { TrainerEarningsItems, TrainerEarningsReport } from '@mfw/common';
import type { BaseApiResponse } from './types/api.types';
import type {
  TrainerEarningsArgs,
  TrainerEarningsItemsArgs,
} from './types/trainerEarnings.types';

import { get } from './axios';

export const fetchTrainerEarnings = async ({
  currency,
  from,
  granularity,
  organizationId,
  to,
}: TrainerEarningsArgs) => {
  const response = await get<BaseApiResponse<TrainerEarningsReport>>(
    `/v2/organizations/${organizationId}/performance/trainer-earnings`,
    // `.strict()` DTO: exactly these keys — the tenant stays in the cache key
    { query: { currency, from, granularity, to } },
  );
  return response?.data ?? null;
};

export const fetchTrainerEarningsItems = async ({
  currency,
  from,
  limit,
  offset,
  organizationId,
  to,
  trainerId,
}: TrainerEarningsItemsArgs) => {
  const response = await get<BaseApiResponse<TrainerEarningsItems>>(
    `/v2/organizations/${organizationId}/performance/trainer-earnings/items`,
    {
      query: {
        currency,
        from,
        limit: String(limit),
        offset: String(offset),
        to,
        trainerId,
      },
    },
  );
  return response?.data ?? null;
};
